const localizers = {
  'loading.msg': () => `Yükleniyor...`,
  'logon.message.msg': () => `Kimlik doğrulaması gerekli. Geçerli bir kullanıcı kimliği ve parolası girin.`,
  'logon.button.msg': () => `Oturum aç...`,
  'SASServer.logonError.msg': () => `Sunucuya oturum açılamıyor.`,
  'SASServer.genericError.msg': () => `Sunucuya erişim sağlanamadı.`,
}
export default localizers;
